<template>
  <div class="row row-border">
    <div class="col-8 fill">
      <img v-if="imageSrc" :src="imageSrc" :alt="imageSrc" />
      <div v-else class="no-image-icon">
        <font-awesome-icon
          icon="fa-regular fa-image"
          size="xl"
          color="primary"
        />
        <div class="q-mt-md">Suggested image size: 756 x 280</div>
      </div>
      <div v-if="memberOnly" class="member-only-tag">
        <span> member-only </span>
      </div>
    </div>
    <div class="col-4 promo-content">
      <div class="tiles-promo-description">
        <span class="promo-name"> {{ title }} </span>
        <span class="promo-text" v-html="description"> </span>
        <a :href="sanitizeUrl(link)" class="promo-button" target="_blank">
          <span> {{ buttonTitle }} </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { sanitizeUrl } from "@braintree/sanitize-url";
export default {
  name: "promoPreview",

  props: {
    imageSrc: String,
    title: String,
    description: String,
    link: String,
    buttonTitle: String,
    memberOnly: Boolean,
  },

  data() {
    return {
      sanitizeUrl,
    };
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.row-border {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 16px;
  border: 1px solid gray;
  max-width: 1140px;
  min-height: 280px;
}

.fill {
  position: relative;
  overflow: hidden;
}
.fill img {
  max-width: 100%;
  float: left;
}

.member-only-tag {
  position: absolute;
  bottom: 0;
  height: 27px;
  background-color: #303030;
  width: 100%;
}

.member-only-tag span {
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
}

.member-only-tag span:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 0.1875em;
  background: #dc2a2a;
  bottom: 0;
  left: 0;
}

.promo-content {
  max-height: 18em;
  overflow: hidden;
  padding-left: 0.75em;
}

.tiles-promo-description {
  padding: 0.5em 2em 0.5em 0.5em;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  height: 100%;
  max-width: 364px;
  margin: 0 auto;
  color: #272f33;
}

.promo-name {
  white-space: normal;
  width: 100%;
  font-size: 2em;
  letter-spacing: 0.5px;
  line-height: 0.95em;
  text-align: center;
  color: #000;
  font-weight: 700;
}

.promo-text {
  white-space: normal;
  margin: 0.5em 0;
  max-height: 8em;
  font-size: 1em;
  line-height: 1.4em;
  overflow: hidden;
  max-width: 100%;
  text-align: center;
}

.promo-button {
  display: -webkit-flex;
  display: flex;
  background-color: #fbc734;
  color: #000 !important;
  text-decoration: none !important;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  height: 3em;
  max-width: 22.5em;
  margin: 0.5em 0;
  border-radius: 4px;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-weight: 700;
}

.no-image-icon {
  height: 260px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    height: 50px;
  }
}
</style>
